var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 20.16C7.48784 20.16 3.83984 16.512 3.83984 12C3.83984 7.488 7.48784 3.84 11.9998 3.84C16.5118 3.84 20.1598 7.488 20.1598 12C20.1598 16.512 16.5118 20.16 11.9998 20.16ZM11.9998 4.8C8.01584 4.8 4.79984 8.016 4.79984 12C4.79984 15.984 8.01584 19.2 11.9998 19.2C15.9838 19.2 19.1998 15.984 19.1998 12C19.1998 8.016 15.9838 4.8 11.9998 4.8Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67969 11.52H16.3197V12.48H7.67969V11.52Z",
    fill: "#CBCBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5195 7.67999H12.4795V16.32H11.5195V7.67999Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.4781a3500836d9f233f09d3e20d6d686.svg";
export { ForwardRef as ReactComponent };